export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";